import React from "react";
import "./AboutSection.css";
import { GiWitchFlight } from "react-icons/gi";
import { Link } from "react-router-dom";
import { FaLocationArrow, FaPhoneAlt } from "react-icons/fa";
const AboutSection = () => {
  return (
    <div className="about-area ptb-100 position-relative z-1">
      <div className="container">
        <div
          className="row align-items-center"
          data-cue="slideInUp"
          data-show="true"
          style={{
            animationName: "slideInUp",
            animationDuration: "600ms",
            animationTimingFunction: "ease",
            animationDelay: "0ms",
            animationDirection: "normal",
            animationFillMode: "both",
          }}
        >
          <div className="col-lg-6 col-md-12">
            <div className="about-image">
              <div className="row">
                <div className="col-lg-6 col-sm-6">
                  <div className="image">
                    <img
                      src="https://wphtml.com/html/tf/avelo/assets/images/about/about1.jpg"
                      alt="about-image"
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <div className="image position-relative">
                    <img
                      src="https://wphtml.com/html/tf/avelo/assets/images/about/about2.jpg"
                      alt="about-image"
                    />
                    <div className="experience">
                      <img
                        src="/Images/safdasdf.png"
                        // src="https://wphtml.com/html/tf/avelo/assets/images/about/ribbons.png"
                        alt="ribbons"
                      />
                      <span className="d-block fw-bold">
                        25 Years <br />
                        of Experience
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="about-content">
              <span className="d-block sub-title fw-bold">
                What will you get
              </span>
              <h2>
                Streamlined Flight Booking for Travel Agencies with YatriService
              </h2>
              <p>
                Streamlined Flight Management for Agents, Tailored for Quick
                Bookings and Hassle-Free Operations. Optimized Solutions for
                Seamless Travel Services.
              </p>
              <ul className="features-list ps-0 list-unstyled">
                <li className="position-relative ">
                  <img
                    src="https://cdn-icons-png.freepik.com/512/1355/1355566.png?uid=R155952951&ga=GA1.1.12114912.1717589849"
                    alt=""
                    style={{
                      height: "32px",
                      width: "32px",
                      marginRight: "15px",
                    }}
                  />
                  {/* <GiWitchFlight className="ph ph-check" style={{marginRight:'10px'}}/> */}
                  Simplified flight booking process with real-time updates and
                  easy access to airline data.
                </li>
                <li className="position-relative ">
                  <img
                    src="https://cdn-icons-png.freepik.com/512/1355/1355566.png?uid=R155952951&ga=GA1.1.12114912.1717589849"
                    alt=""
                    style={{
                      height: "32px",
                      width: "32px",
                      marginRight: "15px",
                    }}
                  />
                  {/* <GiWitchFlight className="ph ph-check" style={{marginRight:'10px'}}/> */}
                  Fast and seamless platform to manage multiple bookings and
                  provide clients with the best options
                </li>
              </ul>
              <div className="d-flex align-items-center">
                <Link className="default-btn" to='/about-us'>
                  About Us
                  <FaLocationArrow style={{marginLeft:'10px'}} className="ph ph-arrow-right" />
                </Link>
                <div className="call-info d-flex align-items-center">
                  <div className="icon">
                    <FaPhoneAlt className="ph-fill ph-phone-call" color="#8b3eea"/>
                  </div>
                  <div className="info">
                    <span className="d-block">CALL ANYTIME</span>
                    <Link to="tel:+919717039543" className="fw-bold">
                      + 91-9717039543
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="shape1">
        <img
          src="https://wphtml.com/html/tf/avelo/assets/images/shapes/shape1.png"
          alt="shape1"
        />
      </div>
    </div>
  );
};

export default AboutSection;
